<template>
  <transition name="dok-toast-pop">
    <div
      class="dok-toast"
      v-show="visible"
      :class="customClass"
      :style="{
        padding: !iconName ? '4px 8px' : '12px 16px',
        'min-width': !iconName ? '48px' : '96px'
      }"
    >
      <dok-icon
        v-if="iconName"
        :name="iconName"
        style="font-size: 40px"
      />
      <span
        class="dok-toast-text"
        :style="{ 'padding-top': iconName === '' ? '0' : '8px' }"
      >{{ message }}</span>
    </div>
  </transition>
</template>

<script>
import DokIcon from '../DokIcon'

export default {
  props: {
    message: String,
    className: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'middle'
    },
    iconName: {
      type: String,
      default: ''
    }
  },
  components: { DokIcon },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    customClass() {
      return [`place-${this.position || 'middle'}`, this.className].join(' ')
    }
  }
}
</script>

<style lang="scss">
.dok-toast {
  position: fixed;
  max-width: 80%;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  box-sizing: border-box;
  text-align: center;
  z-index: 1000000;
  transition: opacity 0.3s linear;

  &-text {
    font-size: 14px;
    display: block;
    text-align: center;
  }

  &-pop-enter,
  &-pop-leave-active {
    opacity: 0;
  }
}
.place-top {
  top: 50px;
  left: 50%;
  transform: translate(-50%, 0);
}

.place-middle {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.place-bottom {
  bottom: 50px;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
